{
  "empty": {
    "context": {
      "filters": {
        "excludeFirstTryPasses": true,
        "excludePasteHeavy": true,
        "from": "2020-01-01T00:00:00Z",
        "gated": "gated",
        "to": "2020-12-31T00:00:00Z"
      },
      "minN": 30,
      "releaseLines": []
    },
    "figures": [
      {
        "extras": {
          "at": null,
          "n": 0,
          "nStudents": 0,
          "p20": null,
          "p80": null,
          "parts": null,
          "tooFew": null,
          "weekly": null
        },
        "name": "ai_assist_scope",
        "shape": "number",
        "unit": "count",
        "value": null
      },
      {
        "extras": {
          "at": null,
          "n": 0,
          "nStudents": 0,
          "p20": null,
          "p80": null,
          "parts": null,
          "tooFew": null,
          "weekly": null
        },
        "name": "attempts_to_done",
        "shape": "number",
        "unit": "attempts",
        "value": null
      },
      {
        "extras": {
          "at": null,
          "n": 0,
          "nStudents": 0,
          "p20": null,
          "p80": null,
          "parts": null,
          "tooFew": null,
          "weekly": null
        },
        "name": "score_gain_per_attempt",
        "shape": "number",
        "unit": "pp",
        "value": null
      },
      {
        "extras": {
          "at": null,
          "n": 0,
          "nStudents": 0,
          "p20": null,
          "p80": null,
          "parts": null,
          "tooFew": null,
          "weekly": null
        },
        "name": "helpful_share",
        "shape": "number",
        "unit": "%",
        "value": null
      },
      {
        "extras": {
          "at": null,
          "n": 0,
          "nStudents": 0,
          "p20": null,
          "p80": null,
          "parts": null,
          "tooFew": null,
          "weekly": null
        },
        "name": "vote_rate",
        "shape": "number",
        "unit": "%",
        "value": null
      },
      {
        "extras": {
          "at": null,
          "n": 0,
          "nStudents": 0,
          "p20": null,
          "p80": null,
          "parts": null,
          "tooFew": null,
          "weekly": null
        },
        "name": "paste_heavy_share",
        "shape": "number",
        "unit": "%",
        "value": null
      },
      {
        "extras": {
          "at": null,
          "n": 0,
          "nStudents": 0,
          "p20": null,
          "p80": null,
          "parts": null,
          "tooFew": null,
          "weekly": null
        },
        "name": "stuck_students",
        "shape": "number",
        "unit": "count",
        "value": null
      },
      {
        "axis": "attempt",
        "extras": {
          "at": null,
          "n": null,
          "nStudents": null,
          "p20": null,
          "p80": null,
          "parts": null,
          "tooFew": null,
          "weekly": null
        },
        "name": "score_by_attempt",
        "shape": "points",
        "unit": "%",
        "value": []
      },
      {
        "axis": "sessionWeek",
        "extras": {
          "at": null,
          "n": null,
          "nStudents": null,
          "p20": null,
          "p80": null,
          "parts": null,
          "tooFew": null,
          "weekly": null
        },
        "name": "score_by_session_week",
        "shape": "points",
        "unit": "%",
        "value": []
      },
      {
        "axis": "week",
        "extras": {
          "at": null,
          "n": null,
          "nStudents": null,
          "p20": null,
          "p80": null,
          "parts": null,
          "tooFew": null,
          "weekly": null
        },
        "name": "helpful_votes:week",
        "shape": "points",
        "unit": "count",
        "value": []
      },
      {
        "axis": "week",
        "extras": {
          "at": null,
          "n": null,
          "nStudents": null,
          "p20": null,
          "p80": null,
          "parts": null,
          "tooFew": null,
          "weekly": null
        },
        "name": "vote_rate:week",
        "shape": "points",
        "unit": "%",
        "value": []
      },
      {
        "extras": {
          "at": null,
          "n": null,
          "nStudents": null,
          "p20": null,
          "p80": null,
          "parts": null,
          "tooFew": null,
          "weekly": null
        },
        "name": "thumbs_down_reasons",
        "shape": "list",
        "unit": "count",
        "value": []
      }
    ]
  },
  "ready": {
    "context": {
      "filters": {
        "excludeFirstTryPasses": false,
        "excludePasteHeavy": false,
        "from": "2026-10-01T00:00:00Z",
        "gated": "gated",
        "to": "2026-11-01T00:00:00Z"
      },
      "minN": 30,
      "releaseLines": []
    },
    "figures": [
      {
        "extras": {
          "at": null,
          "n": 42,
          "nStudents": 30,
          "p20": null,
          "p80": null,
          "parts": null,
          "tooFew": false,
          "weekly": [
            {
              "extras": {
                "at": null,
                "n": 6,
                "nStudents": 6,
                "p20": null,
                "p80": null,
                "parts": null,
                "tooFew": true,
                "weekly": null
              },
              "value": 5,
              "x": "2026-09-28"
            },
            {
              "extras": {
                "at": null,
                "n": 14,
                "nStudents": 14,
                "p20": null,
                "p80": null,
                "parts": null,
                "tooFew": true,
                "weekly": null
              },
              "value": 13,
              "x": "2026-10-05"
            },
            {
              "extras": {
                "at": null,
                "n": 10,
                "nStudents": 10,
                "p20": null,
                "p80": null,
                "parts": null,
                "tooFew": true,
                "weekly": null
              },
              "value": 9,
              "x": "2026-10-12"
            }
          ]
        },
        "name": "ai_assist_scope",
        "shape": "number",
        "unit": "count",
        "value": 42.0
      },
      {
        "extras": {
          "at": null,
          "n": 30,
          "nStudents": 30,
          "p20": null,
          "p80": null,
          "parts": null,
          "tooFew": false,
          "weekly": [
            {
              "extras": {
                "at": null,
                "n": 6,
                "nStudents": 6,
                "p20": null,
                "p80": null,
                "parts": null,
                "tooFew": true,
                "weekly": null
              },
              "value": 1,
              "x": "2026-09-28"
            },
            {
              "extras": {
                "at": null,
                "n": 14,
                "nStudents": 14,
                "p20": null,
                "p80": null,
                "parts": null,
                "tooFew": true,
                "weekly": null
              },
              "value": 1,
              "x": "2026-10-05"
            },
            {
              "extras": {
                "at": null,
                "n": 10,
                "nStudents": 10,
                "p20": null,
                "p80": null,
                "parts": null,
                "tooFew": true,
                "weekly": null
              },
              "value": 1,
              "x": "2026-10-12"
            }
          ]
        },
        "name": "attempts_to_done",
        "shape": "number",
        "unit": "attempts",
        "value": 1
      },
      {
        "extras": {
          "at": null,
          "n": 30,
          "nStudents": 30,
          "p20": null,
          "p80": null,
          "parts": null,
          "tooFew": false,
          "weekly": [
            {
              "extras": {
                "at": null,
                "n": 6,
                "nStudents": 6,
                "p20": null,
                "p80": null,
                "parts": null,
                "tooFew": true,
                "weekly": null
              },
              "value": 5.0,
              "x": "2026-09-28"
            },
            {
              "extras": {
                "at": null,
                "n": 14,
                "nStudents": 14,
                "p20": null,
                "p80": null,
                "parts": null,
                "tooFew": true,
                "weekly": null
              },
              "value": 7.5,
              "x": "2026-10-05"
            },
            {
              "extras": {
                "at": null,
                "n": 10,
                "nStudents": 10,
                "p20": null,
                "p80": null,
                "parts": null,
                "tooFew": true,
                "weekly": null
              },
              "value": 6.2,
              "x": "2026-10-12"
            }
          ]
        },
        "name": "score_gain_per_attempt",
        "shape": "number",
        "unit": "pp",
        "value": 7.5
      },
      {
        "extras": {
          "at": null,
          "n": 20,
          "nStudents": 20,
          "p20": null,
          "p80": null,
          "parts": null,
          "tooFew": true,
          "weekly": [
            {
              "extras": {
                "at": null,
                "n": 4,
                "nStudents": 4,
                "p20": null,
                "p80": null,
                "parts": null,
                "tooFew": true,
                "weekly": null
              },
              "value": 45.5,
              "x": "2026-09-28"
            },
            {
              "extras": {
                "at": null,
                "n": 10,
                "nStudents": 10,
                "p20": null,
                "p80": null,
                "parts": null,
                "tooFew": true,
                "weekly": null
              },
              "value": 45.5,
              "x": "2026-10-05"
            },
            {
              "extras": {
                "at": null,
                "n": 6,
                "nStudents": 6,
                "p20": null,
                "p80": null,
                "parts": null,
                "tooFew": true,
                "weekly": null
              },
              "value": 45.5,
              "x": "2026-10-12"
            }
          ]
        },
        "name": "helpful_share",
        "shape": "number",
        "unit": "%",
        "value": 45.5
      },
      {
        "extras": {
          "at": null,
          "n": 30,
          "nStudents": 30,
          "p20": null,
          "p80": null,
          "parts": null,
          "tooFew": false,
          "weekly": [
            {
              "extras": {
                "at": null,
                "n": 6,
                "nStudents": 6,
                "p20": null,
                "p80": null,
                "parts": null,
                "tooFew": true,
                "weekly": null
              },
              "value": 60.67,
              "x": "2026-09-28"
            },
            {
              "extras": {
                "at": null,
                "n": 14,
                "nStudents": 14,
                "p20": null,
                "p80": null,
                "parts": null,
                "tooFew": true,
                "weekly": null
              },
              "value": 65.0,
              "x": "2026-10-05"
            },
            {
              "extras": {
                "at": null,
                "n": 10,
                "nStudents": 10,
                "p20": null,
                "p80": null,
                "parts": null,
                "tooFew": true,
                "weekly": null
              },
              "value": 54.6,
              "x": "2026-10-12"
            }
          ]
        },
        "name": "vote_rate",
        "shape": "number",
        "unit": "%",
        "value": 60.67
      },
      {
        "extras": {
          "at": null,
          "n": 30,
          "nStudents": 30,
          "p20": null,
          "p80": null,
          "parts": null,
          "tooFew": false,
          "weekly": [
            {
              "extras": {
                "at": null,
                "n": 6,
                "nStudents": 6,
                "p20": null,
                "p80": null,
                "parts": null,
                "tooFew": true,
                "weekly": null
              },
              "value": 0.0,
              "x": "2026-09-28"
            },
            {
              "extras": {
                "at": null,
                "n": 14,
                "nStudents": 14,
                "p20": null,
                "p80": null,
                "parts": null,
                "tooFew": true,
                "weekly": null
              },
              "value": 0.0,
              "x": "2026-10-05"
            },
            {
              "extras": {
                "at": null,
                "n": 10,
                "nStudents": 10,
                "p20": null,
                "p80": null,
                "parts": null,
                "tooFew": true,
                "weekly": null
              },
              "value": 0.0,
              "x": "2026-10-12"
            }
          ]
        },
        "name": "paste_heavy_share",
        "shape": "number",
        "unit": "%",
        "value": 0.0
      },
      {
        "extras": {
          "at": null,
          "n": 0,
          "nStudents": 0,
          "p20": null,
          "p80": null,
          "parts": null,
          "tooFew": null,
          "weekly": null
        },
        "name": "stuck_students",
        "shape": "number",
        "unit": "count",
        "value": null
      },
      {
        "axis": "attempt",
        "extras": {
          "at": null,
          "n": null,
          "nStudents": null,
          "p20": null,
          "p80": null,
          "parts": null,
          "tooFew": null,
          "weekly": null
        },
        "name": "score_by_attempt",
        "shape": "points",
        "unit": "%",
        "value": [
          {
            "extras": {
              "at": null,
              "n": 30,
              "nStudents": null,
              "p20": 50.0,
              "p80": 151.5,
              "parts": {
                "0": 7.0,
                "50": 8.0,
                "100": 8.0,
                "151.5": 7.0
              },
              "tooFew": false,
              "weekly": null
            },
            "value": 100.0,
            "x": 1
          }
        ]
      },
      {
        "axis": "sessionWeek",
        "extras": {
          "at": null,
          "n": null,
          "nStudents": null,
          "p20": null,
          "p80": null,
          "parts": null,
          "tooFew": null,
          "weekly": null
        },
        "name": "score_by_session_week",
        "shape": "points",
        "unit": "%",
        "value": [
          {
            "extras": {
              "at": null,
              "n": 30,
              "nStudents": null,
              "p20": 50.0,
              "p80": 151.5,
              "parts": {
                "0": 7.0,
                "50": 8.0,
                "100": 8.0,
                "151.5": 7.0
              },
              "tooFew": false,
              "weekly": null
            },
            "value": 100.0,
            "x": 2
          }
        ]
      },
      {
        "axis": "week",
        "extras": {
          "at": null,
          "n": null,
          "nStudents": null,
          "p20": null,
          "p80": null,
          "parts": null,
          "tooFew": null,
          "weekly": null
        },
        "name": "helpful_votes:week",
        "shape": "points",
        "unit": "count",
        "value": [
          {
            "extras": {
              "at": null,
              "n": 4,
              "nStudents": null,
              "p20": null,
              "p80": null,
              "parts": {
                "helpful": 2.0,
                "notHelpful": 2.0
              },
              "tooFew": true,
              "weekly": null
            },
            "value": 2,
            "x": "2026-09-28"
          },
          {
            "extras": {
              "at": null,
              "n": 10,
              "nStudents": null,
              "p20": null,
              "p80": null,
              "parts": {
                "helpful": 5.0,
                "notHelpful": 5.0
              },
              "tooFew": true,
              "weekly": null
            },
            "value": 5,
            "x": "2026-10-05"
          },
          {
            "extras": {
              "at": null,
              "n": 6,
              "nStudents": null,
              "p20": null,
              "p80": null,
              "parts": {
                "helpful": 3.0,
                "notHelpful": 3.0
              },
              "tooFew": true,
              "weekly": null
            },
            "value": 3,
            "x": "2026-10-12"
          }
        ]
      },
      {
        "axis": "week",
        "extras": {
          "at": null,
          "n": null,
          "nStudents": null,
          "p20": null,
          "p80": null,
          "parts": null,
          "tooFew": null,
          "weekly": null
        },
        "name": "vote_rate:week",
        "shape": "points",
        "unit": "%",
        "value": [
          {
            "extras": {
              "at": null,
              "n": 6,
              "nStudents": null,
              "p20": null,
              "p80": null,
              "parts": null,
              "tooFew": true,
              "weekly": null
            },
            "value": 60.67,
            "x": "2026-09-28"
          },
          {
            "extras": {
              "at": null,
              "n": 14,
              "nStudents": null,
              "p20": null,
              "p80": null,
              "parts": null,
              "tooFew": true,
              "weekly": null
            },
            "value": 65.0,
            "x": "2026-10-05"
          },
          {
            "extras": {
              "at": null,
              "n": 10,
              "nStudents": null,
              "p20": null,
              "p80": null,
              "parts": null,
              "tooFew": true,
              "weekly": null
            },
            "value": 54.6,
            "x": "2026-10-12"
          }
        ]
      },
      {
        "extras": {
          "at": null,
          "n": null,
          "nStudents": null,
          "p20": null,
          "p80": null,
          "parts": null,
          "tooFew": null,
          "weekly": null
        },
        "name": "thumbs_down_reasons",
        "shape": "list",
        "unit": "count",
        "value": [
          {
            "extras": {
              "at": "2026-10-15",
              "n": null,
              "nStudents": null,
              "p20": null,
              "p80": null,
              "parts": null,
              "tooFew": null,
              "weekly": null
            },
            "key": "anon-reason-01",
            "label": "Sample reason A",
            "value": 1.0
          },
          {
            "extras": {
              "at": "2026-10-14",
              "n": null,
              "nStudents": null,
              "p20": null,
              "p80": null,
              "parts": null,
              "tooFew": null,
              "weekly": null
            },
            "key": "anon-reason-02",
            "label": "Sample reason B",
            "value": 1.0
          },
          {
            "extras": {
              "at": "2026-10-12",
              "n": null,
              "nStudents": null,
              "p20": null,
              "p80": null,
              "parts": null,
              "tooFew": null,
              "weekly": null
            },
            "key": "anon-reason-03",
            "label": "Sample reason C",
            "value": 1.0
          },
          {
            "extras": {
              "at": "2026-10-11",
              "n": null,
              "nStudents": null,
              "p20": null,
              "p80": null,
              "parts": null,
              "tooFew": null,
              "weekly": null
            },
            "key": "anon-reason-04",
            "label": "Sample reason A",
            "value": 1.0
          },
          {
            "extras": {
              "at": "2026-10-09",
              "n": null,
              "nStudents": null,
              "p20": null,
              "p80": null,
              "parts": null,
              "tooFew": null,
              "weekly": null
            },
            "key": "anon-reason-05",
            "label": "Sample reason B",
            "value": 1.0
          },
          {
            "extras": {
              "at": "2026-10-08",
              "n": null,
              "nStudents": null,
              "p20": null,
              "p80": null,
              "parts": null,
              "tooFew": null,
              "weekly": null
            },
            "key": "anon-reason-06",
            "label": "Sample reason C",
            "value": 1.0
          },
          {
            "extras": {
              "at": "2026-10-06",
              "n": null,
              "nStudents": null,
              "p20": null,
              "p80": null,
              "parts": null,
              "tooFew": null,
              "weekly": null
            },
            "key": "anon-reason-07",
            "label": "Sample reason A",
            "value": 1.0
          },
          {
            "extras": {
              "at": "2026-10-05",
              "n": null,
              "nStudents": null,
              "p20": null,
              "p80": null,
              "parts": null,
              "tooFew": null,
              "weekly": null
            },
            "key": "anon-reason-08",
            "label": "Sample reason B",
            "value": 1.0
          },
          {
            "extras": {
              "at": "2026-10-03",
              "n": null,
              "nStudents": null,
              "p20": null,
              "p80": null,
              "parts": null,
              "tooFew": null,
              "weekly": null
            },
            "key": "anon-reason-09",
            "label": "Sample reason C",
            "value": 1.0
          },
          {
            "extras": {
              "at": "2026-10-02",
              "n": null,
              "nStudents": null,
              "p20": null,
              "p80": null,
              "parts": null,
              "tooFew": null,
              "weekly": null
            },
            "key": "anon-reason-10",
            "label": "Sample reason A",
            "value": 1.0
          }
        ]
      }
    ]
  },
  "tooFew": {
    "context": {
      "filters": {
        "excludeFirstTryPasses": true,
        "excludePasteHeavy": true,
        "from": "2026-10-01T00:00:00Z",
        "gated": "gated",
        "to": "2026-11-01T00:00:00Z"
      },
      "minN": 30,
      "releaseLines": []
    },
    "figures": [
      {
        "extras": {
          "at": null,
          "n": 8,
          "nStudents": 8,
          "p20": null,
          "p80": null,
          "parts": null,
          "tooFew": true,
          "weekly": [
            {
              "extras": {
                "at": null,
                "n": 1,
                "nStudents": 1,
                "p20": null,
                "p80": null,
                "parts": null,
                "tooFew": true,
                "weekly": null
              },
              "value": 1,
              "x": "2026-09-28"
            },
            {
              "extras": {
                "at": null,
                "n": 4,
                "nStudents": 4,
                "p20": null,
                "p80": null,
                "parts": null,
                "tooFew": true,
                "weekly": null
              },
              "value": 3,
              "x": "2026-10-05"
            },
            {
              "extras": {
                "at": null,
                "n": 3,
                "nStudents": 3,
                "p20": null,
                "p80": null,
                "parts": null,
                "tooFew": true,
                "weekly": null
              },
              "value": 3,
              "x": "2026-10-12"
            }
          ]
        },
        "name": "ai_assist_scope",
        "shape": "number",
        "unit": "count",
        "value": 7
      },
      {
        "extras": {
          "at": null,
          "n": 8,
          "nStudents": 8,
          "p20": null,
          "p80": null,
          "parts": null,
          "tooFew": true,
          "weekly": [
            {
              "extras": {
                "at": null,
                "n": 1,
                "nStudents": 1,
                "p20": null,
                "p80": null,
                "parts": null,
                "tooFew": true,
                "weekly": null
              },
              "value": 1,
              "x": "2026-09-28"
            },
            {
              "extras": {
                "at": null,
                "n": 4,
                "nStudents": 4,
                "p20": null,
                "p80": null,
                "parts": null,
                "tooFew": true,
                "weekly": null
              },
              "value": 1,
              "x": "2026-10-05"
            },
            {
              "extras": {
                "at": null,
                "n": 3,
                "nStudents": 3,
                "p20": null,
                "p80": null,
                "parts": null,
                "tooFew": true,
                "weekly": null
              },
              "value": 1,
              "x": "2026-10-12"
            }
          ]
        },
        "name": "attempts_to_done",
        "shape": "number",
        "unit": "attempts",
        "value": 1
      },
      {
        "extras": {
          "at": null,
          "n": 0,
          "nStudents": 0,
          "p20": null,
          "p80": null,
          "parts": null,
          "tooFew": null,
          "weekly": [
            {
              "extras": {
                "at": null,
                "n": 0,
                "nStudents": 0,
                "p20": null,
                "p80": null,
                "parts": null,
                "tooFew": false,
                "weekly": null
              },
              "value": null,
              "x": "2026-09-28"
            },
            {
              "extras": {
                "at": null,
                "n": 0,
                "nStudents": 0,
                "p20": null,
                "p80": null,
                "parts": null,
                "tooFew": false,
                "weekly": null
              },
              "value": null,
              "x": "2026-10-05"
            },
            {
              "extras": {
                "at": null,
                "n": 0,
                "nStudents": 0,
                "p20": null,
                "p80": null,
                "parts": null,
                "tooFew": false,
                "weekly": null
              },
              "value": null,
              "x": "2026-10-12"
            }
          ]
        },
        "name": "score_gain_per_attempt",
        "shape": "number",
        "unit": "pp",
        "value": null
      },
      {
        "extras": {
          "at": null,
          "n": 6,
          "nStudents": 6,
          "p20": null,
          "p80": null,
          "parts": null,
          "tooFew": true,
          "weekly": [
            {
              "extras": {
                "at": null,
                "n": 1,
                "nStudents": 1,
                "p20": null,
                "p80": null,
                "parts": null,
                "tooFew": true,
                "weekly": null
              },
              "value": 0.0,
              "x": "2026-09-28"
            },
            {
              "extras": {
                "at": null,
                "n": 2,
                "nStudents": 2,
                "p20": null,
                "p80": null,
                "parts": null,
                "tooFew": true,
                "weekly": null
              },
              "value": 43.5,
              "x": "2026-10-05"
            },
            {
              "extras": {
                "at": null,
                "n": 3,
                "nStudents": 3,
                "p20": null,
                "p80": null,
                "parts": null,
                "tooFew": true,
                "weekly": null
              },
              "value": 58.0,
              "x": "2026-10-12"
            }
          ]
        },
        "name": "helpful_share",
        "shape": "number",
        "unit": "%",
        "value": 43.5
      },
      {
        "extras": {
          "at": null,
          "n": 8,
          "nStudents": 8,
          "p20": null,
          "p80": null,
          "parts": null,
          "tooFew": true,
          "weekly": [
            {
              "extras": {
                "at": null,
                "n": 1,
                "nStudents": 1,
                "p20": null,
                "p80": null,
                "parts": null,
                "tooFew": true,
                "weekly": null
              },
              "value": 87.0,
              "x": "2026-09-28"
            },
            {
              "extras": {
                "at": null,
                "n": 4,
                "nStudents": 4,
                "p20": null,
                "p80": null,
                "parts": null,
                "tooFew": true,
                "weekly": null
              },
              "value": 43.5,
              "x": "2026-10-05"
            },
            {
              "extras": {
                "at": null,
                "n": 3,
                "nStudents": 3,
                "p20": null,
                "p80": null,
                "parts": null,
                "tooFew": true,
                "weekly": null
              },
              "value": 87.0,
              "x": "2026-10-12"
            }
          ]
        },
        "name": "vote_rate",
        "shape": "number",
        "unit": "%",
        "value": 65.25
      },
      {
        "extras": {
          "at": null,
          "n": 8,
          "nStudents": 8,
          "p20": null,
          "p80": null,
          "parts": null,
          "tooFew": true,
          "weekly": [
            {
              "extras": {
                "at": null,
                "n": 1,
                "nStudents": 1,
                "p20": null,
                "p80": null,
                "parts": null,
                "tooFew": true,
                "weekly": null
              },
              "value": 0.0,
              "x": "2026-09-28"
            },
            {
              "extras": {
                "at": null,
                "n": 4,
                "nStudents": 4,
                "p20": null,
                "p80": null,
                "parts": null,
                "tooFew": true,
                "weekly": null
              },
              "value": 0.0,
              "x": "2026-10-05"
            },
            {
              "extras": {
                "at": null,
                "n": 3,
                "nStudents": 3,
                "p20": null,
                "p80": null,
                "parts": null,
                "tooFew": true,
                "weekly": null
              },
              "value": 0.0,
              "x": "2026-10-12"
            }
          ]
        },
        "name": "paste_heavy_share",
        "shape": "number",
        "unit": "%",
        "value": 0.0
      },
      {
        "extras": {
          "at": null,
          "n": 0,
          "nStudents": 0,
          "p20": null,
          "p80": null,
          "parts": null,
          "tooFew": null,
          "weekly": null
        },
        "name": "stuck_students",
        "shape": "number",
        "unit": "count",
        "value": null
      },
      {
        "axis": "attempt",
        "extras": {
          "at": null,
          "n": null,
          "nStudents": null,
          "p20": null,
          "p80": null,
          "parts": null,
          "tooFew": null,
          "weekly": null
        },
        "name": "score_by_attempt",
        "shape": "points",
        "unit": "%",
        "value": [
          {
            "extras": {
              "at": null,
              "n": 8,
              "nStudents": null,
              "p20": 39.67,
              "p80": 54.29,
              "parts": {
                "40": 1.0,
                "44": 1.0,
                "48": 1.0,
                "52": 1.0,
                "56": 1.0,
                "60": 1.0,
                "64": 1.0,
                "68": 1.0
              },
              "tooFew": true,
              "weekly": null
            },
            "value": 46.98,
            "x": 1
          }
        ]
      },
      {
        "axis": "sessionWeek",
        "extras": {
          "at": null,
          "n": null,
          "nStudents": null,
          "p20": null,
          "p80": null,
          "parts": null,
          "tooFew": null,
          "weekly": null
        },
        "name": "score_by_session_week",
        "shape": "points",
        "unit": "%",
        "value": [
          {
            "extras": {
              "at": null,
              "n": 8,
              "nStudents": null,
              "p20": 39.67,
              "p80": 54.29,
              "parts": {
                "40": 1.0,
                "44": 1.0,
                "48": 1.0,
                "52": 1.0,
                "56": 1.0,
                "60": 1.0,
                "64": 1.0,
                "68": 1.0
              },
              "tooFew": true,
              "weekly": null
            },
            "value": 46.98,
            "x": 1
          }
        ]
      },
      {
        "axis": "week",
        "extras": {
          "at": null,
          "n": null,
          "nStudents": null,
          "p20": null,
          "p80": null,
          "parts": null,
          "tooFew": null,
          "weekly": null
        },
        "name": "helpful_votes:week",
        "shape": "points",
        "unit": "count",
        "value": [
          {
            "extras": {
              "at": null,
              "n": 1,
              "nStudents": null,
              "p20": null,
              "p80": null,
              "parts": {
                "helpful": 0.0,
                "notHelpful": 1.0
              },
              "tooFew": true,
              "weekly": null
            },
            "value": 0.0,
            "x": "2026-09-28"
          },
          {
            "extras": {
              "at": null,
              "n": 2,
              "nStudents": null,
              "p20": null,
              "p80": null,
              "parts": {
                "helpful": 1.0,
                "notHelpful": 1.0
              },
              "tooFew": true,
              "weekly": null
            },
            "value": 1,
            "x": "2026-10-05"
          },
          {
            "extras": {
              "at": null,
              "n": 3,
              "nStudents": null,
              "p20": null,
              "p80": null,
              "parts": {
                "helpful": 2.0,
                "notHelpful": 1.0
              },
              "tooFew": true,
              "weekly": null
            },
            "value": 2,
            "x": "2026-10-12"
          }
        ]
      },
      {
        "axis": "week",
        "extras": {
          "at": null,
          "n": null,
          "nStudents": null,
          "p20": null,
          "p80": null,
          "parts": null,
          "tooFew": null,
          "weekly": null
        },
        "name": "vote_rate:week",
        "shape": "points",
        "unit": "%",
        "value": [
          {
            "extras": {
              "at": null,
              "n": 1,
              "nStudents": null,
              "p20": null,
              "p80": null,
              "parts": null,
              "tooFew": true,
              "weekly": null
            },
            "value": 87.0,
            "x": "2026-09-28"
          },
          {
            "extras": {
              "at": null,
              "n": 4,
              "nStudents": null,
              "p20": null,
              "p80": null,
              "parts": null,
              "tooFew": true,
              "weekly": null
            },
            "value": 43.5,
            "x": "2026-10-05"
          },
          {
            "extras": {
              "at": null,
              "n": 3,
              "nStudents": null,
              "p20": null,
              "p80": null,
              "parts": null,
              "tooFew": true,
              "weekly": null
            },
            "value": 87.0,
            "x": "2026-10-12"
          }
        ]
      },
      {
        "extras": {
          "at": null,
          "n": null,
          "nStudents": null,
          "p20": null,
          "p80": null,
          "parts": null,
          "tooFew": null,
          "weekly": null
        },
        "name": "thumbs_down_reasons",
        "shape": "list",
        "unit": "count",
        "value": [
          {
            "extras": {
              "at": "2026-10-15",
              "n": null,
              "nStudents": null,
              "p20": null,
              "p80": null,
              "parts": null,
              "tooFew": null,
              "weekly": null
            },
            "key": "anon-reason-01",
            "label": "Sample reason A",
            "value": 1.0
          },
          {
            "extras": {
              "at": "2026-10-05",
              "n": null,
              "nStudents": null,
              "p20": null,
              "p80": null,
              "parts": null,
              "tooFew": null,
              "weekly": null
            },
            "key": "anon-reason-02",
            "label": "Sample reason B",
            "value": 1.0
          },
          {
            "extras": {
              "at": "2026-10-03",
              "n": null,
              "nStudents": null,
              "p20": null,
              "p80": null,
              "parts": null,
              "tooFew": null,
              "weekly": null
            },
            "key": "anon-reason-03",
            "label": "Sample reason C",
            "value": 1.0
          }
        ]
      }
    ]
  },
  "ungated": {
    "context": {
      "filters": {
        "excludeFirstTryPasses": true,
        "excludePasteHeavy": true,
        "from": "2026-10-01T00:00:00Z",
        "gated": "ungated",
        "to": "2026-11-01T00:00:00Z"
      },
      "minN": 30,
      "releaseLines": []
    },
    "figures": [
      {
        "extras": {
          "at": null,
          "n": 0,
          "nStudents": 0,
          "p20": null,
          "p80": null,
          "parts": null,
          "tooFew": null,
          "weekly": null
        },
        "name": "ai_assist_scope",
        "shape": "number",
        "unit": "count",
        "value": null
      },
      {
        "extras": {
          "at": null,
          "n": 0,
          "nStudents": 0,
          "p20": null,
          "p80": null,
          "parts": null,
          "tooFew": null,
          "weekly": null
        },
        "name": "attempts_to_done",
        "shape": "number",
        "unit": "attempts",
        "value": null
      },
      {
        "extras": {
          "at": null,
          "n": 0,
          "nStudents": 0,
          "p20": null,
          "p80": null,
          "parts": null,
          "tooFew": null,
          "weekly": null
        },
        "name": "score_gain_per_attempt",
        "shape": "number",
        "unit": "pp",
        "value": null
      },
      {
        "extras": {
          "at": null,
          "n": 0,
          "nStudents": 0,
          "p20": null,
          "p80": null,
          "parts": null,
          "tooFew": null,
          "weekly": null
        },
        "name": "helpful_share",
        "shape": "number",
        "unit": "%",
        "value": null
      },
      {
        "extras": {
          "at": null,
          "n": 0,
          "nStudents": 0,
          "p20": null,
          "p80": null,
          "parts": null,
          "tooFew": null,
          "weekly": null
        },
        "name": "vote_rate",
        "shape": "number",
        "unit": "%",
        "value": null
      },
      {
        "extras": {
          "at": null,
          "n": 0,
          "nStudents": 0,
          "p20": null,
          "p80": null,
          "parts": null,
          "tooFew": null,
          "weekly": null
        },
        "name": "paste_heavy_share",
        "shape": "number",
        "unit": "%",
        "value": null
      },
      {
        "extras": {
          "at": null,
          "n": 0,
          "nStudents": 0,
          "p20": null,
          "p80": null,
          "parts": null,
          "tooFew": null,
          "weekly": null
        },
        "name": "stuck_students",
        "shape": "number",
        "unit": "count",
        "value": null
      },
      {
        "axis": "attempt",
        "extras": {
          "at": null,
          "n": null,
          "nStudents": null,
          "p20": null,
          "p80": null,
          "parts": null,
          "tooFew": null,
          "weekly": null
        },
        "name": "score_by_attempt",
        "shape": "points",
        "unit": "%",
        "value": []
      },
      {
        "axis": "sessionWeek",
        "extras": {
          "at": null,
          "n": null,
          "nStudents": null,
          "p20": null,
          "p80": null,
          "parts": null,
          "tooFew": null,
          "weekly": null
        },
        "name": "score_by_session_week",
        "shape": "points",
        "unit": "%",
        "value": []
      },
      {
        "axis": "week",
        "extras": {
          "at": null,
          "n": null,
          "nStudents": null,
          "p20": null,
          "p80": null,
          "parts": null,
          "tooFew": null,
          "weekly": null
        },
        "name": "helpful_votes:week",
        "shape": "points",
        "unit": "count",
        "value": []
      },
      {
        "axis": "week",
        "extras": {
          "at": null,
          "n": null,
          "nStudents": null,
          "p20": null,
          "p80": null,
          "parts": null,
          "tooFew": null,
          "weekly": null
        },
        "name": "vote_rate:week",
        "shape": "points",
        "unit": "%",
        "value": []
      },
      {
        "extras": {
          "at": null,
          "n": null,
          "nStudents": null,
          "p20": null,
          "p80": null,
          "parts": null,
          "tooFew": null,
          "weekly": null
        },
        "name": "thumbs_down_reasons",
        "shape": "list",
        "unit": "count",
        "value": []
      }
    ]
  }
}
